import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { Center, Loader, Modal, Text, Button, Stack } from '@mantine/core';
import { IconLock } from '@tabler/icons-react';
import { useAuth } from '../../../features/auth/contexts/AuthContext';
import { tokenManager } from '../../../features/auth/api';

interface PrivateRouteProps {
  children: ReactNode;
  allowedRoles?: string[]; // 許可するロールのリスト
}

export const PrivateRoute = ({ children, allowedRoles }: PrivateRouteProps) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Center h="100vh">
        <Loader size="lg" />
      </Center>
    );
  }

  // 🔧 修正: AuthContextのuserまたはトークンの存在をチェック
  // これにより、状態同期の競合状態にも対応
  const hasValidToken = tokenManager.hasToken();
  
  if (!user && !hasValidToken) {
    return <Navigate to="/login" replace />;
  }

  // ロールベースのアクセス制御
  if (allowedRoles && allowedRoles.length > 0 && user) {
    const hasAccess = allowedRoles.includes(user.role);
    
    if (!hasAccess) {
      return (
        <Center h="100vh">
          <Modal
            opened={true}
            onClose={() => window.history.back()}
            title={
              <Stack gap="xs">
                <IconLock size={32} color="red" />
                <Text size="lg" fw={700}>アクセス権限がありません</Text>
              </Stack>
            }
            centered
          >
            <Stack gap="md">
              <Text size="sm" c="dimmed">
                この機能にアクセスする権限がありません。
              </Text>
              <Text size="sm" c="dimmed">
                必要な権限: {allowedRoles.join(', ')}
              </Text>
              <Text size="sm" c="dimmed">
                あなたの権限: {user.role}
              </Text>
              <Button 
                fullWidth 
                onClick={() => window.history.back()}
                variant="light"
              >
                戻る
              </Button>
            </Stack>
          </Modal>
        </Center>
      );
    }
  }

  return <>{children}</>;
};